<section
  id="contact-us"
  class="section section--{{ color }}">

  <div class="contact-us contact-us--{{ color }} container-md">
    <p class="section__witty">Let's Talk</p>

    <div class="row">
      <div class="col-12 col-sm-6">
        @if (bookDemo) {
          <h2 class="section__title">
            Book a 30-minute personalized demo of the QuickSeries Connect app.
          </h2>

          <div class="section__description section__description--no-columns">
            <p>
              Discover how it can seamlessly fit into your budget and strategy.
              Let us show you the full range of QuickSeries Connect's benefits and how
              it can help you achieve your goals.
            </p>
            <p>
              Contact us and an Account Manager will get back to you within 48 hours.
            </p>
          </div>
        }

        @if (!bookDemo) {
          <h2 class="section__title">
            Get in touch with us for free samples, personalized products, and quotes.
          </h2>

          <p class="section__description section__description--no-columns">
            Contact us and an Account Manager will get back to you in 48 hours.
          </p>
        }

        <a
          class="contact-us__phone"
          href="tel:18003614653">

          <span class="qs-icon qs-icon--phone qs-icon--medium"></span>1-800-361-4653
        </a>

        <a
          class="contact-us__email"
          href="mailto:info@quickseries.com">

          <span class="qs-icon qs-icon--email-action-unread qs-icon--medium"></span>info&#64;quickseries.com
        </a>
      </div>

      <div class="col-12 col-sm-6">
        <form
          class="qs-form qs-form--{{ color }}"
          novalidate
          [formGroup]="form"
          (ngSubmit)="submit()">

          <p class="qs-form__required">
            * required
          </p>

          <fieldset class="qs-form__fieldset">
            <label
              class="qs-form__label"
              for="name">

              Name
              <span class="qs-form__required">*</span>
            </label>
            <input
              type="text"
              id="name"
              placeholder="Enter your name here"
              formControlName="fullName">
            @if (fullName?.errors?.['required'] && (fullName?.touched || fullName?.dirty)) {
              <p class="qs-form__required qs-form__error">
                This field is required.
              </p>
            }

            <label
              class="qs-form__label"
              for="phone-number">

              Phone number
              <span class="qs-form__required">*</span>
            </label>
            <input
              type="text"
              id="phone-number"
              placeholder="1-800-361-4653"
              formControlName="phoneNumber">
            @if (phoneNumber?.errors?.['required'] && (phoneNumber?.touched || phoneNumber?.dirty)) {
              <p class="qs-form__required qs-form__error">
                This field is required.
              </p>
            }

            <label
              class="qs-form__label"
              for="email">

              Email
              <span class="qs-form__required">*</span>
            </label>
            <input
              type="email"
              id="email"
              placeholder="email@domain.com"
              formControlName="email">
            @if (email?.errors?.['required'] && (email?.touched || email?.dirty)) {
              <p class="qs-form__required qs-form__error">
                This field is required.
              </p>
            }
            @if (email?.errors?.['email'] && (email?.touched || email?.dirty)) {
              <p class="qs-form__required qs-form__error">
                Enter a valid email address.
              </p>
            }

            <label
              class="qs-form__label"
              for="organization">

              Organization / Corporation
              <span class="qs-form__required">*</span>
            </label>
            <input
              type="text"
              id="organization"
              placeholder="QuickSeries Publishing, Inc."
              formControlName="organization">
            @if (organization?.errors?.['required'] && (organization?.touched || organization?.dirty)) {
              <p class="qs-form__required qs-form__error">
                This field is required.
              </p>
            }

            <label
              class="qs-form__label"
              for="message">

              Message
              <span class="qs-form__required">*</span>
            </label>
            <textarea
              name="message"
              id="message"
              placeholder="Enter your message here..."
              rows="6"
              formControlName="message"></textarea>
            @if (message?.errors?.['required'] && (message?.touched || message?.dirty)) {
              <p class="qs-form__required qs-form__error">
                This field is required.
              </p>
            }
          </fieldset>

          <fieldset class="qs-form__fieldset">
            <legend class="qs-form__legend">
              Join our mailing list for exclusive offers and news about Quickseries&reg; products.
            </legend>

            <input
              type="checkbox"
              class="qs-form__input"
              id="newsletter"
              name="newsletterOptIn"
              formControlName="newsletterOptIn">
            <label
              for="newsletter"
              class="qs-label__label">

              Sign me up!
            </label>
          </fieldset>

          @if (isSuccessfullySubmitted !== null) {
            <app-alert-box
              [type]="isSuccessfullySubmitted ? alertBoxType.SUCCESS : alertBoxType.ERROR"
              [config]="alertBoxConfig"
              (closeBox)="dismissAlertBox()" />
          }

          <button
            type="submit"
            class="qs-btn qs-btn--{{ getSubmitBtnColor() }}">

            Send
          </button>
        </form>
      </div>
    </div>
  </div>
</section>
